//@flow

import React, { useState } from 'react';
import styled from 'styled-components';
import { StyledLabel } from 'modules/external_tenant/components/index/FormsSectionComponent';
import { Field, ErrorMessage } from 'formik';
import { Auth } from 'utils/ExportCommon';
import PhoneCode from 'components/shared/PhoneCodeComponent';
import MoneyInput from 'components/shared/MoneyInputComponent';
import { RequiredFieldSchema } from 'validations/HomieValidations';

const WrapperExternal = styled.div`
  text-align: left;
`;

const StyledValidatedInput = styled.div`
  position: relative;
  margin-bottom: 20px;
`;

const StyledInput = styled(Field)`
  display: block;
  width: 100%;
  height: 35px;
  padding: 10px 15px;
  border: 1px solid #ececec;
  border-radius: 2px;
  background-color: white;
  line-height: 35px;
  font-size: 14px;
`;

const StyledErrorMessage = styled(ErrorMessage)`
  color: red;
  position: absolute;
  top: 35px;
  font-size: 14px;
`;

const Wsapp = styled.img.attrs({
  src: Auth.wsapp
})`
  float: right;
  position: absolute;
  top: 6px;
  right: 9px;
`;

const StyledPhoneErrorMessage = styled(StyledErrorMessage)`
  position: static;
  text-align: left;
  top: 0;
`;

const StyledSpan = styled(StyledLabel)`
  font-size: 14px;
  color: #9b9b9b;
  margin-bottom: 25px;
`;

export default function FormFieldsSignUp({
  externalTenant,
  errors,
  touched,
  countryCode,
  handleCountryCodePicked,
  values,
  setFieldValue
}: any) {
  const onChange = (value: string | number, name: string) => {
    setFieldValue(name, value);
  };
  if (externalTenant) {
    const [isPickingCode, setPickingCode] = useState(false);
    const [code, setCode] = useState(countryCode);

    return (
      <WrapperExternal>
        <StyledLabel>Datos del inmueble</StyledLabel>
        <StyledValidatedInput>
          <StyledInput
            type="text"
            name="neighborhood"
            placeholder="Colonia"
            className={
              errors.neighborhood && touched.neighborhood ? 'has-error' : ''
            }
          />
          <StyledErrorMessage name="neighborhood" component="div" />
        </StyledValidatedInput>
        <StyledLabel>Precio del inmueble</StyledLabel>
        <StyledValidatedInput>
          <MoneyInput
            textAlign="left"
            name="price"
            value={values.price}
            onValueChange={onChange}
            currency="MXN"
            currencySign="$"
            isValidated={true}
            schema={RequiredFieldSchema}
            errorMessagePosition="relative"
            errorMessageTop="0"
          />
        </StyledValidatedInput>
        <StyledLabel>Datos del propietario</StyledLabel>
        <StyledValidatedInput>
          <StyledInput
            type="text"
            name="full_name"
            placeholder="Nombre del propietario (opcional)"
          />
        </StyledValidatedInput>
        <StyledValidatedInput>
          <StyledInput
            type="text"
            name="owner_email"
            placeholder="Correo del propietario (opcional)"
          />
        </StyledValidatedInput>
        <StyledValidatedInput>
          <PhoneCode
            handleCountryCodeClick={() => {
              setPickingCode(!isPickingCode);
            }}
            handleCountryCodePicked={element => {
              setCode(element.value);
              handleCountryCodePicked(element.value);
              setPickingCode(!isPickingCode);
            }}
            pickingCountryCode={isPickingCode}
            countryCode={code}
            errors={errors.external_phone}
            touched={touched.external_phone}
            name="external_phone"
            placeHolder="Número de whatsapp del propietario"
            placeHolderFontSize={11}
          />
          <Wsapp />
          <StyledPhoneErrorMessage name="external_phone" component="div" />
        </StyledValidatedInput>
        <StyledSpan>
          Es necesario que tengas el contacto del inmueble en el que deseas
          vivir.
        </StyledSpan>
      </WrapperExternal>
    );
  }

  return null;
}
